/* global process */
let base = window._env_.VUE_APP_IMG_FLOW_HOST
export const getImgFlowModelTable = params => {
  return axios.get(`${base}/read_model_list`, params)
}
export const getImgFlowModelDetail = params => {
  return axios.get(`${base}/read_model_detail/${params.id}`, {params})
}
// export const exportImgFlowModelData = params => {
//   return axios.get(`${base}/exportImgFlowModelData/${params.id}`, {params})
// }
// export const createImgFlowModelData = params => {
//   return axios.post(`${base}/createImgFlowModelData`, params)
// }
// export const updateImgFlowModelData = params => {
//   return axios.post(`${base}/updateImgFlowModelData/${params.id}`, params)
// }
// export const deleteImgFlowModelData = params => {
//   return axios.post(`${base}/deleteImgFlowModelData/${params.id}`, params)
// }



// WEBPACK FOOTER //
// ./src/views/img-flow-model/img-flow-model.api.js